import { Card, CardBody, Col } from "reactstrap";
import Swal from "sweetalert2";
import { Btn } from "../../../../AbstractElements";
import { InfoAlertTitle, Informational } from "../../../../Constants/Constants";
import { InfoAlertSubTitle } from "../../../../Data/BonusUi/SweetAlert";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";

const InfoAlert = () => {
  const handleAlert = () => {
    Swal.fire({
      text: "Please Click on this button it's big surprise for you.",
      confirmButtonText: "ok",
    }).then((result) => {
      result.isConfirmed && Swal.fire({ text: "Thank you for visit Moscow theme: true" });
    });
  };
  return (
    <Col xxl="3" lg="4" sm="6" xs="12">
      <Card className="height-equal">
        <CommonCardHeader title={InfoAlertTitle} span={InfoAlertSubTitle} />
        <CardBody className="btn-showcase">
          <Btn color="info" className="sweet-4" onClick={handleAlert}>
            {Informational}
          </Btn>
        </CardBody>
      </Card>
    </Col>
  );
};

export default InfoAlert;
